import React from 'react';
import { Form } from 'react-bootstrap';
import Icon from '../../common/Icons';
import { HEAD_DOCTOR_COPY } from '../headDoctorCopy';
import { REPORTS_PERIOD_PRESETS } from './reportsNavConfig';

const DEFAULT_COPY = HEAD_DOCTOR_COPY.REPORTS;

export default function ReportsFilterBar({
  copy = DEFAULT_COPY,
  allowAllSites = true,
  showSiteFilter,
  showCompanyFilter,
  from,
  to,
  siteFilter,
  companyFilter = '',
  workSites = [],
  companies = [],
  loading,
  activePreset,
  onFromChange,
  onToChange,
  onSiteChange,
  onCompanyChange,
  onPreset,
  onRefresh,
  children
}) {
  const visibleSiteFilter =
    showSiteFilter ?? (workSites.length > 1 || (allowAllSites && workSites.length > 0));
  const visibleCompanyFilter =
    showCompanyFilter ?? (typeof onCompanyChange === 'function' && Array.isArray(companies));

  return (
    <div className="hd-reports-filterbar" aria-label={copy.FILTER_BAR_ARIA}>
      <div className="hd-reports-filterbar__presets" role="group" aria-label={copy.FILTER_PERIOD}>
        {REPORTS_PERIOD_PRESETS.map((preset) => (
          <button
            key={preset.key}
            type="button"
            className={`hd-reports-preset${activePreset === preset.key ? ' is-active' : ''}`}
            onClick={() => onPreset(preset)}
            disabled={loading}
            aria-pressed={activePreset === preset.key}
          >
            {copy[preset.labelKey]}
          </button>
        ))}
      </div>

      <div className="hd-reports-filterbar__controls">
        <div className="hd-reports-filterbar__range">
          <label className="hd-reports-filterbar__field">
            <span className="hd-reports-filterbar__label">{copy.FILTER_DATE_FROM}</span>
            <Form.Control
              type="date"
              size="sm"
              value={from}
              max={to}
              onChange={(e) => onFromChange(e.target.value)}
              disabled={loading}
              aria-label={copy.FILTER_DATE_FROM}
            />
          </label>
          <span className="hd-reports-filterbar__sep" aria-hidden>
            →
          </span>
          <label className="hd-reports-filterbar__field">
            <span className="hd-reports-filterbar__label">{copy.FILTER_DATE_TO}</span>
            <Form.Control
              type="date"
              size="sm"
              value={to}
              min={from}
              onChange={(e) => onToChange(e.target.value)}
              disabled={loading}
              aria-label={copy.FILTER_DATE_TO}
            />
          </label>
        </div>

        {visibleSiteFilter ? (
          <label className="hd-reports-filterbar__field hd-reports-filterbar__field--site">
            <span className="hd-reports-filterbar__label">{copy.FILTER_SITE_SHORT}</span>
            <Form.Select
              size="sm"
              value={siteFilter}
              onChange={(e) => onSiteChange(e.target.value)}
              disabled={loading}
              aria-label={copy.FILTER_SITE_ARIA}
            >
              {allowAllSites ? <option value="">{copy.FILTER_ALL_SITES}</option> : null}
              {workSites.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.name}
                </option>
              ))}
            </Form.Select>
          </label>
        ) : null}

        {visibleCompanyFilter ? (
          <label className="hd-reports-filterbar__field hd-reports-filterbar__field--company">
            <span className="hd-reports-filterbar__label">{copy.FILTER_COMPANY_SHORT}</span>
            <Form.Select
              size="sm"
              value={companyFilter}
              onChange={(e) => onCompanyChange(e.target.value)}
              disabled={loading}
              aria-label={copy.FILTER_COMPANY_ARIA}
            >
              <option value="">{copy.FILTER_ALL_COMPANIES}</option>
              {companies.map((company) => (
                <option key={company.id} value={String(company.id)}>
                  {company.name}
                </option>
              ))}
            </Form.Select>
          </label>
        ) : null}

        {children}

        <button
          type="button"
          className="hd-reports-refresh-btn"
          onClick={onRefresh}
          disabled={loading}
          aria-label={copy.REFRESH_ARIA}
          title={copy.REFRESH_ARIA}
        >
          <Icon name="refresh" size={18} className={loading ? 'hd-reports-refresh-btn__icon--spin' : ''} />
          <span className="d-none d-md-inline">{copy.REFRESH_LABEL}</span>
        </button>
      </div>
    </div>
  );
}
